var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 7.5,
    stroke: "#C6C6C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1666 20.667C28.1666 22.0477 27.0474 23.167 25.6666 23.167C24.2859 23.167 23.1666 22.0477 23.1666 20.667C23.1666 19.2863 24.2859 18.167 25.6666 18.167C27.0474 18.167 28.1666 19.2863 28.1666 20.667ZM25.6666 22.167C26.495 22.167 27.1666 21.4954 27.1666 20.667C27.1666 19.8386 26.495 19.167 25.6666 19.167C24.8382 19.167 24.1666 19.8386 24.1666 20.667C24.1666 21.4954 24.8382 22.167 25.6666 22.167Z",
    fill: "#535353"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8334 27.333C19.8334 28.7137 20.9527 29.833 22.3334 29.833C23.7141 29.833 24.8334 28.7137 24.8334 27.333C24.8334 25.9523 23.7141 24.833 22.3334 24.833C20.9527 24.833 19.8334 25.9523 19.8334 27.333ZM22.3334 28.833C21.5049 28.833 20.8334 28.1614 20.8334 27.333C20.8334 26.5046 21.5049 25.833 22.3334 25.833C23.1618 25.833 23.8334 26.5046 23.8334 27.333C23.8334 28.1614 23.1618 28.833 22.3334 28.833Z",
    fill: "#535353"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 27.3057C25.5 27.0295 25.7239 26.8057 26 26.8057H30.6667C30.9428 26.8057 31.1667 27.0295 31.1667 27.3057C31.1667 27.5818 30.9428 27.8057 30.6667 27.8057H26C25.7239 27.8057 25.5 27.5818 25.5 27.3057Z",
    fill: "#535353"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20.1387C22.2762 20.1387 22.5 20.3625 22.5 20.6387C22.5 20.9148 22.2762 21.1387 22 21.1387H17.3334C17.0572 21.1387 16.8334 20.9148 16.8334 20.6387C16.8334 20.3625 17.0572 20.1387 17.3334 20.1387H22Z",
    fill: "#535353"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8334 27.3057C16.8334 27.0295 17.0572 26.8057 17.3334 26.8057H18.6667C18.9428 26.8057 19.1667 27.0295 19.1667 27.3057C19.1667 27.5818 18.9428 27.8057 18.6667 27.8057H17.3334C17.0572 27.8057 16.8334 27.5818 16.8334 27.3057Z",
    fill: "#535353"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 20.1387C30.9428 20.1387 31.1667 20.3625 31.1667 20.6387C31.1667 20.9148 30.9428 21.1387 30.6667 21.1387H29.3334C29.0572 21.1387 28.8334 20.9148 28.8334 20.6387C28.8334 20.3625 29.0572 20.1387 29.3334 20.1387H30.6667Z",
    fill: "#535353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.e64cdb6790418bc2aad7c7ce7a6c9185.svg";
export { ForwardRef as ReactComponent };